export const OrderStatus = Object.freeze({
	PENDING: "Pending",
	PAID: "Paid",
	COMPLETED: "Completed",
	CANCELLED: "Cancelled",
	FAILED: "Failed",
	ASSIGNED: "Assigned to courier",
	IN_TRANSIT: "In transit",
	DELIVERED: "Delivered",
	RETURNED: "Returned",
	TO_BE_REASSIGNED: "To be reassigned",
});
